import { combineReducers } from 'redux';
import User from './UserManagement/UserManagement.reducer';
import Account from './Account/Account.reducer';
import DashboardConfig from './DashboardConfig/DashboardConfig.reducer';
import Navigation from './Navigation/Navigation.reducer';
import Recommendations from '../Modules/Predict/redux/Recommendations/Recommendations.reducer';
import Attribution from './Attribution/Attribution.reducer';
import BusinessProfile from './BusinessProfile/BusinessProfile.reducer';
import Insights from './Insights/Insights.reducer';
import Segment from './Segment/Segment.reducer';
import DeepDive from './DeepDive/DeepDive.reducer';
import CompetitorsData from './CompetitorsData/CompetitorsData.reducer';
import CustomDashboard from './CustomDashboard/CustomDashboard.reducer';
import Promotion from './Promotion/Promotion.reducer';
import ConnectorDataReducer from '../Modules/Connect/redux/Connector/ConnectorSlice';
import Invoices from './Finances/Invoices/Invoices.reducer';
import OrderIncome from './Finances/OrderIncome/OrderIncome.reducer';
import Reconciliation from './Finances/Reconciliation/Reconciliation.reducer';
import WorkSpace from './WorkSpace/WorkSpace.reducer';
import Reports from './Reports/Reports.reducer';
import Rca from './Rca/Rca.reducer';
import Connect from 'Modules/Connect/redux/ConnectList/ConnectSlice'; // from connect module
import ListingBatch from 'Modules/Execute/subModules/ListingBatch/redux/listingBatchSlice';
import Orders from './Orders/Orders.reducer';
import Inventory from './Inventory/Inventory.reducer';
import StockValidation from './StockValidation/StockValidation.reducer';
import ProductMaster from './ProductMaster/ProductMaster.reducer';
// import ListingBatch from './ListingBatch/ListingBatch.reducer';
import OfflineOrder from './OfflineOrders/OfflineOrder.reducer';
import MetricDefinition from './MetricDefinition/MetricDefinition.reducer';
import CreditUsage from './CreditUsage/CreditUsage.reducer';
import SubscriptionDetails from './SubscriptionDetails/SubscriptionDetails.reducer';
import Scheduler from './Scheduler/Scheduler.reducer';
import ChannelFilter from './Filter/Filter';
import Homepage from '../Modules/Home/redux/HomePageSlice';
import Hopper from '../Modules/Hopper/redux/H.reducer';
import ExecuteDrawer from './ExecuteDrawer/ExecuteDrawer.reducer';
import dateRangeReducer from './DateRangePicker/dateRangeSlice';
import ConnectJournal from './ConnectJournal/ConnectJournal.reducer';
import ChartFilter from './ChartFilter/ChartFilter.reducer';

export default history =>
  combineReducers({
    // router: connectRouter(history),
    Account,
    Connect,
    User,
    Navigation,
    DashboardConfig,
    Recommendations,
    Attribution,
    BusinessProfile,
    Insights,
    Segment,
    DeepDive,
    CompetitorsData,
    CustomDashboard,
    Promotion,
    ConnectorDataReducer,
    Invoices,
    OrderIncome,
    Reconciliation,
    WorkSpace,
    Reports,
    Rca,
    Orders,
    Inventory,
    ProductMaster,
    ListingBatch,
    OfflineOrder,
    MetricDefinition,
    CreditUsage,
    SubscriptionDetails,
    Scheduler,
    ChannelFilter,
    Homepage,
    Hopper,
    ExecuteDrawer,
    ConnectJournal,
    globalDateRange: dateRangeReducer,
    ChartFilter,
    StockValidation
  });
